<template>
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <!-- P1 and P2 (Trend Line) -->
    <path d="M3 17L8 10" :stroke="color" stroke-width="1.5" stroke-linecap="round"/>
    <circle cx="3" cy="17" r="1.2" :fill="color"/>
    <circle cx="8" cy="10" r="1.2" :fill="color"/>
    
    <!-- P3 (Retracement Point) -->
    <circle cx="6" cy="14" r="1.2" :fill="color"/>
    
    <!-- Extension Lines -->
    <path d="M6 14L17 14" :stroke="color" stroke-width="1" stroke-dasharray="2 2"/>
    <path d="M6 10L17 10" :stroke="color" stroke-width="1" stroke-dasharray="2 2"/>
    <path d="M6 6L17 6" :stroke="color" stroke-width="1" stroke-dasharray="2 2"/>
  </svg>
</template>
<script>
export default {
  name: "fib_extension_tool",
  props: {
    color: {
      type: String,
      default: "#000000"
    }
  }
}
</script>
